import { useAppSelector } from "@app/store";
import Warning from "@assets/icons/warning-filled.svg";
import { Button } from "@components/button";
import { GlobalLoader } from "@components/loader";
import { Modal } from "@components/modal";
import { useRequisitesDispatch } from "@features/requisite";
import { useNavigateWithUserId } from "@hooks/use-navigate";
import { useCallback } from "react";
import styles from "./remove-requisite-confirm.module.scss";

type RemoveRequisiteConfirmProps = {
  requisiteId?: string;
  hide: () => void;
};

export const RemoveRequisiteConfirm = ({
  hide,
  requisiteId,
}: RemoveRequisiteConfirmProps) => {
  const navigate = useNavigateWithUserId();
  const { removeRequisite } = useRequisitesDispatch();
  const isDeleting = useAppSelector((state) => state.requisite.isDeleting);

  const onConfirm = useCallback(async () => {
    if (requisiteId) {
      await removeRequisite(requisiteId);
      navigate("details");
    }
  }, [navigate, removeRequisite, requisiteId]);

  return (
    <>
      <Modal
        isOpen={!!requisiteId}
        onClose={hide}
        className={styles.removeRequisiteConfirm}
      >
        <div className={styles.removeRequisiteConfirmContainer}>
          <Warning />
          <p className={styles.title}>Вы уверены?</p>
          <p className={styles.subTitle}>Добавление в архив</p>
        </div>
        <div className={styles.buttons}>
          <Button type="danger" onClick={onConfirm}>
            Да, удалить
          </Button>
          <Button type="outline" onClick={hide}>
            Нет
          </Button>
        </div>
      </Modal>
      {isDeleting && <GlobalLoader />}
    </>
  );
};
